// extracted by mini-css-extract-plugin
export var baseMailListItemColor = "UWKUc";
export var expandedMailListItemColor = "F7P4e";
export var expandedSelectedHeader = "mGYRE";
export var flaggedMailListItemColor = "iZbPU";
export var flaggedMailListItemColorDeprecated = "SoJX4";
export var pinnedMailListItemColor = "gPZmZ";
export var regularMailListItemColor = "IjQyD";
export var selectedMailListItemColor = "epBmH";
export var selectedMailListItemColorDeprecated = "vl1wI";